module.exports = __webpack_public_path__ + "assets/img/comp_3-1.6960d5c2.png";